@if (isLoading) {
<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
} @else if (loadingSuccess && user && profile && userRole) {
    <div class="flex flex-col sm:flex-row items-center sm:items-start justify-center gap-4 sm:gap-12">
        <div class="w-[360px] sm:w-64">
            <profile-info [user]="user" [profile]="profile" [userRole]="userRole" [relationship]="relationship" [isOwnProfile]="isOwnProfile"></profile-info>
        </div>
        <div class="flex flex-col gap-4 w-[360px] sm:min-w-[360px] sm:max-w-[720px] grow">
            @if (isVisible) {
                <div class="flex flex-col gap-1 bg-slate-100 rounded shadow-sm">
                    <profile-about-section [username]="username" [profile]="profile" [isOwnProfile]="isOwnProfile"></profile-about-section>
                </div>
                <collection-previews [username]="username"></collection-previews>
                <profile-deck-previews [username]="username"></profile-deck-previews>
            } @else {
                <div class="flex flex-col gap-1 bg-slate-100 rounded shadow-sm p-8 text-slate-600 text-center text-sm italic">
                    This profile has been made private by the user.
                </div>
            }
            
        </div>
    </div>
} @else {
    <four-o-four></four-o-four>
}

<preview-item-context-menu></preview-item-context-menu>
